/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Totalbuildslabel2Inputs */

const id_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total build`)
};

const ms_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumlah binaan`)
};

const da_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samlede builds`)
};

const de_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds insgesamt`)
};

const en_us2_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total builds`)
};

const es_es2_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de compilaciones`)
};

const es_mx2_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de compilaciones`)
};

const fil_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabuuang build`)
};

const fr_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des compilations`)
};

const it_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale build`)
};

const hu_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Összes build`)
};

const nl_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal builds`)
};

const no_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt builds`)
};

const pl_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łączna liczba kompilacji`)
};

const pt_br2_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de builds`)
};

const pt_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de compilações`)
};

const ro_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total compilări`)
};

const fi_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koontiversioita yhteensä`)
};

const sv_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt antal byggen`)
};

const vi_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng số bản dựng`)
};

const tr_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toplam yapı`)
};

const cs_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celkem sestavení`)
};

const bg_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общо компилации`)
};

const ru_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего сборок`)
};

const uk_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усього збірок`)
};

const ar_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي البنيات`)
};

const hi_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल बिल्ड`)
};

const th_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์ทั้งหมด`)
};

const ja_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビルド総数`)
};

const zh_cn2_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`构建版本总数`)
};

const zh_hant1_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建置版本總數`)
};

const ko_sandboxes_totalbuildslabel2 = /** @type {(inputs: Sandboxes_Totalbuildslabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 빌드`)
};

/**
* | output |
* | --- |
* | "Total builds" |
*
* @param {Sandboxes_Totalbuildslabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_totalbuildslabel2 = /** @type {((inputs?: Sandboxes_Totalbuildslabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Totalbuildslabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_totalbuildslabel2(inputs)
	if (locale === "ms") return ms_sandboxes_totalbuildslabel2(inputs)
	if (locale === "da") return da_sandboxes_totalbuildslabel2(inputs)
	if (locale === "de") return de_sandboxes_totalbuildslabel2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_totalbuildslabel2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_totalbuildslabel2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_totalbuildslabel2(inputs)
	if (locale === "fil") return fil_sandboxes_totalbuildslabel2(inputs)
	if (locale === "fr") return fr_sandboxes_totalbuildslabel2(inputs)
	if (locale === "it") return it_sandboxes_totalbuildslabel2(inputs)
	if (locale === "hu") return hu_sandboxes_totalbuildslabel2(inputs)
	if (locale === "nl") return nl_sandboxes_totalbuildslabel2(inputs)
	if (locale === "no") return no_sandboxes_totalbuildslabel2(inputs)
	if (locale === "pl") return pl_sandboxes_totalbuildslabel2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_totalbuildslabel2(inputs)
	if (locale === "pt") return pt_sandboxes_totalbuildslabel2(inputs)
	if (locale === "ro") return ro_sandboxes_totalbuildslabel2(inputs)
	if (locale === "fi") return fi_sandboxes_totalbuildslabel2(inputs)
	if (locale === "sv") return sv_sandboxes_totalbuildslabel2(inputs)
	if (locale === "vi") return vi_sandboxes_totalbuildslabel2(inputs)
	if (locale === "tr") return tr_sandboxes_totalbuildslabel2(inputs)
	if (locale === "cs") return cs_sandboxes_totalbuildslabel2(inputs)
	if (locale === "bg") return bg_sandboxes_totalbuildslabel2(inputs)
	if (locale === "ru") return ru_sandboxes_totalbuildslabel2(inputs)
	if (locale === "uk") return uk_sandboxes_totalbuildslabel2(inputs)
	if (locale === "ar") return ar_sandboxes_totalbuildslabel2(inputs)
	if (locale === "hi") return hi_sandboxes_totalbuildslabel2(inputs)
	if (locale === "th") return th_sandboxes_totalbuildslabel2(inputs)
	if (locale === "ja") return ja_sandboxes_totalbuildslabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_totalbuildslabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_totalbuildslabel2(inputs)
	return ko_sandboxes_totalbuildslabel2(inputs)
});
export { sandboxes_totalbuildslabel2 as "sandboxes.totalBuildsLabel" }